export enum QueryKeys {
  PlatformTourReservation = 'platform-tour-reservation',
  SelectedPrivateClassTrack = 'selected-private-class-track',
  UserProfileImage = 'user-profile-image',
  CertificateInfo = 'certificate-info',
  Progress = 'progress',
  MyCoach = 'my-coach',
  AgeRange = 'age-range',
  Languages = 'languages',
}
